module.exports = __webpack_public_path__ + "img/t7-2.a6e6a5b5.svg";